var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Spinner } from "theme-ui";
export const Button = React.forwardRef((_a, ref) => {
    var { variant, fill = false, loading = false } = _a, props = __rest(_a, ["variant", "fill", "loading"]);
    return (_jsxs("button", Object.assign({ ref: ref, sx: {
            width: fill ? "100%" : "auto",
            variant: `buttons.${variant}`
        } }, props, { className: loading ? "loading" : "", children: [loading && (_jsx(Spinner, { strokeWidth: 2, mr: 16, color: "inherit", size: 16 })), props.children] })));
});
export const PrimaryButton = props => (_jsx(Button, Object.assign({ variant: "primary" }, props)));
export const SecondaryButton = props => (_jsx(Button, Object.assign({ variant: "secondary" }, props)));
export const TertiaryButton = props => (_jsx(Button, Object.assign({ variant: "tertiary" }, props)));
export const DestructiveButton = props => (_jsx(Button, Object.assign({ variant: "destructive" }, props)));
export const HollowLightButton = props => (_jsx(Button, Object.assign({ variant: "hollowLight" }, props)));
export const HollowDarkButton = props => (_jsx(Button, Object.assign({ variant: "hollowDark" }, props)));
export const OutlineLightButton = props => (_jsx(Button, Object.assign({ variant: "outlineLight" }, props)));
export const OutlineDarkButton = props => (_jsx(Button, Object.assign({ variant: "outlineDark" }, props)));
//# sourceMappingURL=Button.js.map